/*
 * Copyright © 2025 Apple Inc. Adapted for Bowstring from SF Symbols Version 6.0.
 */

import { type Symbol } from "@bowstring/interfaces";


// noinspection JSUnusedGlobalSymbols
export const _XmarkCircleFill: Symbol = {
  paths:         [
    {
      definition: "M30.5273 15.2695C30.5273 23.6719 23.6719 30.5273 15.2578 30.5273C6.85547 30.5273 0 23.6719 0 15.2695C0 6.85547 6.85547 0 15.2578 0C23.6719 0 30.5273 6.85547 30.5273 15.2695ZM19.6172 9.44531L15.2578 13.7812L10.9219 9.45703C10.7109 9.24609 10.4766 9.14062 10.1719 9.14062C9.57422 9.14062 9.09375 9.59766 9.09375 10.1953C9.09375 10.4883 9.21094 10.7461 9.42188 10.957L13.7461 15.2812L9.42188 19.6055C9.21094 19.8164 9.09375 20.0859 9.09375 20.3672C9.09375 20.9766 9.57422 21.457 10.1719 21.457C10.4766 21.457 10.7461 21.3398 10.957 21.1289L15.2578 16.8047L19.5703 21.1289C19.7812 21.3398 20.0508 21.457 20.3555 21.457C20.9531 21.457 21.4336 20.9766 21.4336 20.3672C21.4336 20.0742 21.3398 19.8047 21.1172 19.5938L16.793 15.2812L21.1289 10.9453C21.3633 10.7109 21.4453 10.4766 21.4453 10.1719C21.4453 9.58594 20.9648 9.11719 20.3789 9.11719C20.0859 9.11719 19.8516 9.21094 19.6172 9.44531Z",
      opacity:    0.85,
    },
  ],
  viewBoxHeight: 30.5508,
  viewBoxWidth:  30.8789,
};
